import Vue from 'vue'
import Router from 'vue-router'

import AppAlumnier from '@/views/AppAlumnier';
import CookiePolicy from '@/views/CookiePolicy';
import Legal from '@/views/Legal';
import Privacy from '@/views/Privacy';

Vue.use(Router);
export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: AppAlumnier,
    },
    {
      path: '/legal',
      component: Legal
    },
    {
      path: '/privacy',
      component: Privacy
    },
    {
      path: '/cookie-policy',
      component: CookiePolicy
    }
  ]
})
